import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';

interface SalesInvoiceOpenInNewTabButtonProps {
  salesInvoiceId: string;
}

export const SalesInvoiceOpenInNewTabButton: React.FC<
  SalesInvoiceOpenInNewTabButtonProps
> = ({ salesInvoiceId }) => {
  const nav = useNavigation();

  return (
    <OverlayTrigger
      trigger={['hover']}
      overlay={<Tooltip>Otwórz fakturę w nowej karcie</Tooltip>}
    >
      <Button
        onClick={e => {
          e.stopPropagation();
          nav.salesInvoiceEditor(salesInvoiceId, true);
        }}
        variant="btn-info"
        className="px-2"
      >
        <Icon.BoxArrowUpRight className="icon-blue" size={16} />
      </Button>
    </OverlayTrigger>
  );
};
